import { ILogger } from './ILogger';
const _loggers: ILogger[] = [];

export const log: ILogger['log'] = (message, data) => {
    if (LOG_LEVEL === 'error' || LOG_LEVEL === 'warn' || LOG_LEVEL === 'off') {
        return;
    }
    _loggers.forEach(l => l.log(message, data));
};
export const warn: ILogger['warn'] = (message, data) => {
    if (LOG_LEVEL === 'error' || LOG_LEVEL === 'off') {
        return;
    }
    _loggers.forEach(l => l.warn(message, data));
};
export const error = (message: string, data?: unknown) => {
    if (LOG_LEVEL === 'off') {
        return;
    }
    let parsedData: Record<string, string> | undefined;
    if (typeof data === 'object' && data) {
        parsedData = Object.getOwnPropertyNames(data).reduce(
            (previous, current) => ({
                ...previous,
                [current]: (data as Record<string, string>)[current]
            }),
            {}
        );
    }
    _loggers.forEach(l =>
        parsedData ? l.error(message, parsedData) : l.error(message)
    );
};

export function addLogger(logger: ILogger): void {
    _loggers.push(logger);
}
